import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Condition } from '@mp/contract-management/conditions/domain';

import { ConditionListItemComponent } from '../condition-list-item/condition-list-item.component';

@Component({
  selector: 'mpctm-conditions-list',
  templateUrl: './conditions-list.component.html',
  styleUrl: './conditions-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConditionListItemComponent],
})
export class ConditionsListComponent {
  @Input() conditions: Condition[] = [];
}
